module.exports = __webpack_public_path__ + "static/media/adrienne-mackey.eb11d7cd.md";